import { AsyncPipe } from '@angular/common'
import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { MatButtonModule } from '@angular/material/button'
import { MatIconModule } from '@angular/material/icon'
import { MatMenuModule } from '@angular/material/menu'
import { MatSlideToggleModule } from '@angular/material/slide-toggle'
import { MatTabsModule } from '@angular/material/tabs'
import { MatToolbarModule } from '@angular/material/toolbar'
import { RouterLink, RouterLinkActive } from '@angular/router'

import { AuthService } from '@auth0/auth0-angular'
import { TranslateModule } from '@ngx-translate/core'
import { SvgIconComponent } from 'angular-svg-icon'
import { takeUntil, tap } from 'rxjs/operators'

import { DestroyDirective } from '~/core/directives'
import { SearchForecastFacade, UiFacade, UserFacade } from '~/core/features'
import { UserNamePipe } from '~/shared/pipes'
import { ADMIN_ROLE, FORECAST_LIST_PATH } from '~const/index'

import { ForecastSearchBarComponent } from './components'

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrl: './header.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  hostDirectives: [DestroyDirective],
  imports: [
    AsyncPipe,
    RouterLink,
    FormsModule,
    UserNamePipe,
    MatIconModule,
    MatMenuModule,
    MatTabsModule,
    TranslateModule,
    MatButtonModule,
    RouterLinkActive,
    SvgIconComponent,
    MatToolbarModule,
    MatSlideToggleModule,
    ForecastSearchBarComponent,
  ],
})
export class HeaderComponent implements OnInit {
  private readonly auth0Service = inject(AuthService, { optional: true })
  private readonly destroy$ = inject(DestroyDirective).destroy$

  uiFacade = inject(UiFacade)

  readonly searchForecastFacade = inject(SearchForecastFacade)

  readonly userFacade = inject(UserFacade)

  FORECAST_LIST_PATH = FORECAST_LIST_PATH
  ADMIN_ROLE = ADMIN_ROLE
  showMobileSearch = false
  isDarkTheme = false

  constructor() {}

  ngOnInit(): void {
    this.uiFacade.isDarkTheme$
      .pipe(
        tap(themeMode => (this.isDarkTheme = themeMode)),
        takeUntil(this.destroy$)
      )
      .subscribe()
  }

  // TODO: Refactor navigation store. Reset search, selected forecast, data
  navigateToHome(): void {
    location.href = '/'
  }

  login(): void {
    this.auth0Service?.loginWithRedirect()
  }

  logout(): void {
    this.auth0Service?.logout({ logoutParams: { returnTo: window.location.origin } })
  }
}
